import { ONGLETS_ANALYSE, type OngletAnalyse } from '@/lib/params-recherche';
import { type TabItem, Tabs } from '@pms-digital/design-system';
import type { ReactNode } from 'react';

const LIBELLES: Record<OngletAnalyse, string> = {
  'avant-apres': 'Avant / après',
  'texte-origine': "Texte d'origine",
  'texte-traduit': 'Texte traduit',
};

/** The label of the tab of an `onglet`, to find it in the page (the package sets no `id` on its tabs). */
export const libelleOngletAnalyse = (onglet: OngletAnalyse): string => LIBELLES[onglet];

interface OngletsAnalyseProps {
  actif: OngletAnalyse;
  onChange: (onglet: OngletAnalyse) => void;
  /** The panel of the active tab: the view it leads to. */
  contenu?: ReactNode;
}

function estOnglet(valeur: string): valeur is OngletAnalyse {
  return ONGLETS_ANALYSE.some((onglet) => onglet === valeur);
}

/**
 * The three tabs of the analysis: "Avant / après", "Texte d'origine" and "Texte traduit" (#10),
 * the `Tabs` of the design system (arrows, `Home` and `End` move from one tab to the next, which
 * then opens, as in the tabs of the result). The panel of the active tab is the one of the
 * package, named by its tab.
 */
export function OngletsAnalyse({ actif, onChange, contenu }: OngletsAnalyseProps) {
  const items: TabItem[] = ONGLETS_ANALYSE.map((onglet) => ({
    value: onglet,
    label: LIBELLES[onglet],
    ...(onglet === actif ? { content: contenu ?? null } : {}),
  }));
  return (
    <div className="mt-6">
      <Tabs
        label="vues de l'analyse"
        items={items}
        value={actif}
        onValueChange={(valeur) => {
          if (estOnglet(valeur)) onChange(valeur);
        }}
      />
    </div>
  );
}
